// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Error$LiteracyplanetClientErrors from "@literacyplanet/client-errors/src/Error.res.mjs";

function Make(S) {
  var useAsync = function () {
    var $$fetch = S.useFetch();
    var match = Error$LiteracyplanetClientErrors.useErrorModal();
    var onSetError = match.onSetError;
    return async function (variables) {
      var match = await $$fetch(variables);
      var error = match.error;
      if (error !== undefined) {
        onSetError({
              TAG: "GraphqlError",
              _0: error,
              _1: [],
              _2: undefined
            });
        return ;
      } else {
        return match.data;
      }
    };
  };
  var use = function (defaultState, onLoading, onResult, onError, skip, variables) {
    var match = React.useState(function () {
          return defaultState();
        });
    var setState = match[1];
    var match$1 = S.use(skip, variables);
    var result = match$1[0];
    var handleResponse = function (response) {
      var result = onResult(response);
      if (result.TAG !== "Ok") {
        return onError(result._0);
      }
      var result$1 = result._0;
      setState(function (param) {
            return result$1;
          });
    };
    React.useEffect((function () {
            if (skip) {
              setState(function (param) {
                    return defaultState();
                  });
            } else {
              var exit = 0;
              if (result.loading) {
                setState(function (state) {
                      return onLoading(state);
                    });
              } else if (result.data !== undefined || result.error !== undefined) {
                exit = 1;
              } else {
                handleResponse({
                      TAG: "Error",
                      _0: {
                        TAG: "GraphqlError",
                        _0: "No Data",
                        _1: [],
                        _2: undefined
                      }
                    });
              }
              if (exit === 1) {
                var response = result.data;
                if (response !== undefined) {
                  handleResponse({
                        TAG: "Ok",
                        _0: Caml_option.valFromOption(response)
                      });
                } else {
                  handleResponse({
                        TAG: "Error",
                        _0: {
                          TAG: "GraphqlError",
                          _0: result.error,
                          _1: [],
                          _2: undefined
                        }
                      });
                }
              }
              
            }
          }), [result]);
    return [
            match[0],
            match$1[1]
          ];
  };
  var useRefetchWithError = function (defaultState, onLoading, onResult, onError, variables) {
    var match = Error$LiteracyplanetClientErrors.useErrorModal();
    var match$1 = use(defaultState, onLoading, (function (res) {
            if (res.TAG === "Ok") {
              return onResult(res._0);
            } else {
              return {
                      TAG: "Error",
                      _0: onError(res._0)
                    };
            }
          }), match.onSetError, false, variables);
    return [
            match$1[0],
            match$1[1]
          ];
  };
  var useSkippableWithErrorModalRefetch = function (defaultState, onLoading, onResult, skip, variables) {
    var match = Error$LiteracyplanetClientErrors.useErrorModal();
    return use(defaultState, onLoading, onResult, match.onSetError, skip, variables);
  };
  var useSkippableWithErrorModal = function (defaultState, onLoading, onResult, skip, variables) {
    return useSkippableWithErrorModalRefetch(defaultState, onLoading, onResult, skip, variables)[0];
  };
  var useWithErrorModal = function (none, none$1, none$2, extra) {
    return useSkippableWithErrorModal(none, none$1, none$2, false, extra);
  };
  return {
          useAsync: useAsync,
          use: use,
          useRefetchWithError: useRefetchWithError,
          useSkippableWithErrorModalRefetch: useSkippableWithErrorModalRefetch,
          useSkippableWithErrorModal: useSkippableWithErrorModal,
          useWithErrorModal: useWithErrorModal
        };
}

export {
  Make ,
}
/* react Not a pure module */
